module.exports = __webpack_public_path__ + "user-bag-page-by-username-2dc74d76/super-ellipse-mask-cd22c3b8c137c9902b90787d046b531a.svg";